import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@material-ui/core/styles';
import Auth from '@cpg-its/ads.auth.auth';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { BrowserRouter } from 'react-router-dom';
import { apiMiddleware } from '../../global/middleware/api-middleware';
import tcsmTheme from '../../global/constants/theme/tcsm-theme';
import { ErrorBoundaryApp } from '../../global/components/error-boundary';
import { CicAppState } from './models/app-models';
import { baseApiReducer } from '../../global/ducks/base-api';
import { authenticatedReducer } from '../../global/ducks/authenticated-slice';
import { globalizationReducer } from '../../global/ducks/globalization';
import { lovProcReducer } from '../../global/ducks/lov-proc-api';
import { tcsmEpiApiReducerWithDefault } from '../../global/ducks/epi-api';
import { DefaultTcsmEpiApiState } from '../../root/tcsm-model';
import { CicNavWrapper } from './cic-nav-wrapper';
import { AuthSetting } from '../../global/constants/auth-settings';
import { appContextApiReducer } from '../../global/ducks/app-context';
import { notificationReducer } from '../../pages/notification/notification-slice';



export const stateReducer = combineReducers<CicAppState>({
	apiState: baseApiReducer,
	authenticatedState: authenticatedReducer,
	globalization: globalizationReducer,
	lovProcState: lovProcReducer,	
	epiProps: tcsmEpiApiReducerWithDefault(DefaultTcsmEpiApiState),
	appContext: appContextApiReducer,
	notificationState: notificationReducer,
});


const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const stateStore = createStore(stateReducer, composeEnhancers(
	applyMiddleware(
		apiMiddleware,
	),
));

const mount = document.getElementById('cic-nav');
if (mount) {
	const appSettings = (window as any).bootstrap;

	ReactDOM.render(
		<Provider store={stateStore}>
			<ThemeProvider theme={tcsmTheme}>
				<BrowserRouter>
					<ErrorBoundaryApp>
						<Auth
							audience={AuthSetting.REACT_APP_AUDIENCE}
							cacheLocation="localstorage"
							clientId={AuthSetting.REACT_APP_CLIENT_ID}
							connection={AuthSetting.REACT_APP_CONNECTION}
							domain={AuthSetting.REACT_APP_DOMAIN}
							redirectUri={window.location.origin}>
							<CicNavWrapper
								navigation={{
									...appSettings?.navigation,
									...appSettings?.cicSettings,
								}}
								signInPath={appSettings?.signInPath}
								signInText={appSettings?.signInText}
								currentCulture={appSettings?.currentCulture}
								siteSettingsId={appSettings?.siteSettingsId}
							/>
						</Auth>
					
					</ErrorBoundaryApp>
				</BrowserRouter>
			</ThemeProvider>
		</Provider>, mount,
	);
}